<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    width="8rem"
    (onHide)="close()">
    <n-header>
        <h1>{{title}}</h1>
        <n-help-link [key]="policyData ? 'antiviruspolicyModify' : 'antiviruspolicyCreate'"></n-help-link>
    </n-header>
    <form [errorMessage]="errorMessage"
        [formGroup]="vm"
        class="common-form">
        <!-- 名称 -->
        <n-form-item [label]="i18n.name"
            [required]="!policyData">
            <input nInput
                style="width: 3.94rem;"
                *ngIf="!policyData"
                id="create-on-demand-policy-name"
                type="text"
                formControlName="name">
            <span *ngIf="policyData">{{policyData.name}}</span>
        </n-form-item>
        <!-- 不扫描文件类型 -->
        <n-form-item [label]="i18n.unscannedFileType">
            <n-multi-input id="create-on-demand-policy-unscanned-file-type"
                style="width: 3.94rem;"
                formControlName="excludeFileType"
                [nTooltip]="i18n.unscannedFileTypeTip"
                nTooltipTrigger="focus"
                nTooltipPlacement="left"
                [seperator]="fileTypeSeperator">
            </n-multi-input>
        </n-form-item>
        <!-- 不扫描文件路径 -->
        <n-form-item [label]="i18n.excludeFilePath">
            <n-multi-input id="create-on-demand-policy-exclude-file-path"
                style="width: 3.94rem;"
                formControlName="excludeFilePath"
                [nTooltip]="i18n.excludeFilePathTip"
                nTooltipTrigger="focus"
                nTooltipPlacement="left"
                [seperator]="filePathSeperator">
            </n-multi-input>
        </n-form-item>
        <!-- 最大可扫描文件大小 -->
        <n-form-item [label]="i18n.maxScanFileSize">
            <div class="inline-flex-wrapper">
                <n-checkbox id="create-on-demand-policy-max-scan-size-checkbox"
                    style="width: .6rem;"
                    [label]="i18n.restricted"
                    formControlName="restricted"
                    (onChange)="onStrategyChange()">
                </n-checkbox>
                <ng-container *ngIf="vm.value.restricted">
                    <n-capacity id="create-on-demand-policy-max-scan-size-capacity"
                        style="width: 3rem"
                        [units]="maxScanCapacityUnit"
                        [nonDecimalUnits]="maxScanCapacityUnit"
                        formControlName="restrictCapacity">
                    </n-capacity>
                    <span>{{restrictCapacityRange}}</span>
                </ng-container>
            </div>
        </n-form-item>
        <!-- 调度类型 -->
        <n-form-item [label]="i18n.scheduleType"
            [required]="true">
            <n-radio-group
                id="create-on-demand-policy-schedule-type-radio-group"
                formControlName="scheduleType"
                (onChange)="onStrategyChange()">
                <n-radio *ngFor="let item of scheduleTypeList"
                    [value]="item.value">
                    <span>{{item.label}}</span>
                </n-radio>
            </n-radio-group>
        </n-form-item>
        <!-- 调度类型为每周 -->
        <ng-container *ngIf="vm.value.scheduleType === ScheduleTypeE.WEEKLY">
            <n-form-item [label]="i18n.week"
                [required]="true">
                <n-checkbox-group
                    id="create-on-demand-policy-weekly-days"
                    formControlName="days">
                    <n-checkbox
                        *ngFor="let item of weekList"
                        [label]="item.label"
                        style="width: 60px;"
                        [value]="item.value">
                    </n-checkbox>
                </n-checkbox-group>
            </n-form-item>
            <!-- 开始时间 -->
            <n-form-item [label]="i18n.startTime"
                [required]="true">
                <n-time id="create-on-demand-policy-start-time-weekly"
                    [showSeconds]="false"
                    formControlName="startTime">
                </n-time>
            </n-form-item>
            <!-- 持续时间 -->
            <n-form-item [label]="i18n.duration"
                [helpContent]="i18n.scanDurationRangeTip"
                [required]="true">
                <div class="duration-time-control">
                    <n-spinner
                        id="create-on-demand-policy-duration-hour-weekly"
                        style="width: .95rem"
                        [onlyInput]="true"
                        [min]="0"
                        [max]="24"
                        formControlName="durationHour">
                    </n-spinner>
                    <span>{{i18n.hour}}</span>
                    <n-spinner
                        id="create-on-demand-policy-duration-minute-weekly"
                        style="width: .95rem"
                        [onlyInput]="true"
                        [min]="0"
                        [max]="59"
                        formControlName="durationMinute">
                    </n-spinner>
                    <span>{{i18n.minute}}</span>
                </div>
            </n-form-item>
        </ng-container>
        <!-- 调度类型为周期 -->
        <ng-container *ngIf="vm.value.scheduleType === ScheduleTypeE.PERIOD">
            <!-- 执行周期 -->
            <n-form-item [label]="i18n.executePeriod"
                [required]="true">
                <span>{{i18n.everyPrep}}</span>
                <n-spinner id="create-on-demand-policy-execute-period"
                    class="execute-period"
                    [min]="1"
                    [max]="30"
                    formControlName="executePeriod">
                </n-spinner>
                <span>{{i18n.performSuffix}}</span>
            </n-form-item>
            <!-- 开始时间 -->
            <n-form-item [label]="i18n.startTime"
                [required]="true">
                <n-time id="create-on-demand-policy-start-time-period"
                    [showSeconds]="false"
                    formControlName="startTime">
                </n-time>
            </n-form-item>
            <!-- 持续时间 -->
            <n-form-item [label]="i18n.duration"
                [helpContent]="vm.value.durationType === DurationTypeE.CUSTOM && i18n.scanDurationRangeTip"
                [required]="true">
                <n-radio-group id="create-on-demand-policy-duration-type-radio-group"
                    block="true"
                    formControlName="durationType"
                    (onChange)="onStrategyChange()">
                    <n-radio [value]="DurationTypeE.CUSTOM"
                        class="custom-radio">
                        <span style="margin-right: .1rem;">{{i18n.custom}}</span>
                        <div *ngIf="vm.value.durationType === DurationTypeE.CUSTOM"
                            class="duration-time-control">
                            <n-spinner id="create-on-demand-policy-duration-hour-period"
                                style="width: .95rem"
                                [onlyInput]="true"
                                [min]="0"
                                [max]="24"
                                formControlName="durationHour">
                            </n-spinner>
                            <span>{{i18n.hour}}</span>
                            <n-spinner id="create-on-demand-policy-duration-minute-period"
                                style="width: .95rem"
                                [onlyInput]="true"
                                [min]="0"
                                [max]="59"
                                formControlName="durationMinute">
                            </n-spinner>
                            <span>{{i18n.minute}}</span>
                        </div>
                    </n-radio>
                    <n-radio [value]="DurationTypeE.UNTILFINISHED">
                        <span>{{i18n.untilFinished}}</span>
                    </n-radio>
                </n-radio-group>
            </n-form-item>
        </ng-container>
    </form>

    <n-footer>
        <button id="create-on-demand-scan-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-on-demand-scan-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
